import './setup'
import app from './app.jsx'

app.init()
